module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetHigh.911ee08.webp";